import axios from "../../../context/axiosConfig";

const pozyczkiAddManualRepayment = async ({
	loanId,
	settlementDate,
	amount,
	description,
	user,
}) => {
	return axios.post("/pozyczki/repayment/add-manual", {
		loanId,
		settlementDate,
		amount,
		description,
		user,
	});
};

export default pozyczkiAddManualRepayment;
